import { GetApplicationResponse } from '@iwoca/lapi-client/edge';
import * as yup from 'yup';

import { createValidatorFromYupSchema } from './stepValidators';
import { TNormalisedStepData } from '../../../types';
import { minimumCompanyDataSchema } from '../../CompanyDetails/CompanyDetailsUK/CompanyDetailsUK.schema';
import { minimumPersonalDataSchema } from '../../PersonalDetails/PersonalDetailsUK/PersonalDetailsUK.schema';

export const passesStep0Validation = (
  normalisedStep0State: TNormalisedStepData['new'],
  applicationData: GetApplicationResponse['data'],
) => {
  const hasEmail = Boolean(normalisedStep0State.email);
  const hasAmount = Boolean(applicationData?.requested_products?.[0].amount);

  return hasEmail && hasAmount;
};

const minimumStep0EligibilityDataSchema = minimumCompanyDataSchema.concat(
  yup.object({
    email: yup.string().required('Email address required'),
  }),
);

export const passesVariantStep0Validation = createValidatorFromYupSchema(
  minimumStep0EligibilityDataSchema,
);

export const businessStepValidator = createValidatorFromYupSchema(
  minimumCompanyDataSchema,
);

export const passesVariantBusinessValidation = (
  applicationData: GetApplicationResponse['data'],
) => Boolean(applicationData?.requested_products?.[0]?.amount);

export const personalStepValidator = createValidatorFromYupSchema(
  minimumPersonalDataSchema,
);
